import { styled } from '@linaria/react';

import ResetButton from '@/components/Sandbox/Toolbar/ResetButton';
import FormatButton from '@/components/Sandbox/Toolbar/FormatButton';

function Toolbar({
  title,
  isFullscreened,
  handleToggleFullscreen,
  handleReset,
  handleFormat,
}) {
  return (
    <Wrapper>
      <Title>{title || 'Code Playground'}</Title>
      <Actions>
        <FormatButton handleFormat={handleFormat} />
        <ResetButton handleReset={handleReset} />
      </Actions>
    </Wrapper>
  );
}

const Wrapper = styled.header`
  --header-top-corner-radius: var(--playground-corner-radius);
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 2rem;
  line-height: 2rem;
  padding-left: var(--encroach-by-left);
  padding-right: var(--encroach-by-right);
  background: var(--color-gray-200);
  border-radius: var(--header-top-corner-radius)
    var(--header-top-corner-radius) 0 0;
`;

const Title = styled.p`
  font-size: 0.875rem;
  font-weight: var(--font-weight-medium);
  color: var(--color-gray-800);
`;

const Actions = styled.div`
  display: flex;
  gap: 8px;
  /* Optical alignment */
  margin-right: -10px;
  color: white;
`;

export default Toolbar;
